export enum FormGroupType {
  Endorsements = 'Endorsements',
  Schedules = 'Schedules',
  Flood = 'Flood'
}